import * as selectors from 'core/middlewares/effects/helpers/selectors';

/**
 * Can change shipping model
 *
 */
export function* canChangeShippingModel() {
  const shippingModelToggle: boolean = yield selectors.settings.getFeatureToggle('shippingModel');
  const cartHasItem: boolean = yield selectors.cart.getCartHasItem();

  if (!shippingModelToggle || cartHasItem) {
    return false;
  }

  return true;
}
